/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable check-file/filename-naming-convention */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationPremiumSpotGroup = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      width={width || presetWidth}
      height={height || presetHeight}
      data-xds="IllustrationPremiumSpotGroup"
      {...props}
    >
      <path
        fill="#FFFFFE"
        fillRule="evenodd"
        d="m27.713 27.803.048-4.933-6.102-.059s-1.884-21.51 8.685-21.408c11.192.11 10.742 11.028 10.728 12.437l-.137 14.092M45.75 49.372v-4.628h-5.725S38.06 24.58 47.978 24.58c10.5 0 10.178 10.247 10.178 11.569v13.222"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M40.951 5.443c3.021 5.633 5.304 15.324 1.91 17.817-.371.273-.86.515-1.426.719l-.039 3.958-1-.01.037-3.646c-2.951.74-7.058.58-8.26-1.181q.075-.264.154-.528l.159-.526c.927-3.053 1.937-5.84 1.937-5.84l1.115.04a1.991 1.991 0 1 0 .145-3.98l-1.74-.064s-7.544-2.29-7.07-9.303c-1.179.798-2.13 2.064-2.872 3.74 1.403.126 2.31.965 2.319 2.61.007 1.294-.357 2.452-1.027 3.699l-.196.353-.382.652a.706.706 0 0 0 .266.974l.09.042 1.434.552-.359.933-1.436-.552a1.706 1.706 0 0 1-.925-2.33l.09-.162.352-.604.185-.332c.598-1.112.914-2.118.908-3.22-.007-1.147-.55-1.597-1.59-1.63l-.123-.001c-.412 1.134-.744 2.421-1 3.85l-.12.712c-.461 2.932-.57 6.034-.464 8.88l.04.877.022.373 5.913.058.013-.073h2.208l-2.004 1.295-.04 4.213-1-.01.041-4.433-6.054-.058-.061-.727-.045-.76c-.157-3.095-.069-6.535.443-9.79l.124-.734a26 26 0 0 1 .877-3.539l-.112.026-.143.036-.238.068-.163.054-.346-.938.205-.069.282-.08q.08-.022.168-.043.373-.09.747-.141c.989-2.446 2.378-4.197 4.224-5.09C28.388.186 37.563-.873 40.95 5.443m-12.073 11.56.93.365c-.326.83-.87 1.407-1.563 1.75a3.55 3.55 0 0 1-1.816.359l-.093-.009.124-.992.037.003c.385.027.86-.036 1.303-.256.423-.21.76-.541.995-1.03zm-.777-6.527a.5.5 0 0 1 .488.415l.007.09-.007.705a.5.5 0 0 1-.993.08l-.007-.09.007-.705a.5.5 0 0 1 .505-.495m-4.364-.043a.5.5 0 0 1 .488.415l.007.09-.007.705a.5.5 0 0 1-.993.08l-.007-.09.007-.705a.5.5 0 0 1 .505-.495m-8.665 1.794 3.867 1.61-.385.923-3.867-1.61zm3.608 3.639v1h-4.19v-1z"
      />
      <path
        fill="#FFFFFE"
        fillRule="evenodd"
        d="M23.123 56.202v-4.907h6.072s2.083-21.383-8.433-21.383c-11.135 0-10.794 10.867-10.794 12.269V56.2"
        clipRule="evenodd"
      />
      <path
        fill="#06A7AC"
        fillRule="evenodd"
        d="M42.433 27.302c-1.829-.549-3.998-.922-6.554-.988-6.8-.18-11.345 1.474-14.297 3.32-.151.093 2.942.433 5.079 3.675 0 0 1.674 5.083 1.821 5.111 2.207.432 4.687.691 7.397.627a26 26 0 0 0 3.809-.368c.135-.023.399-.078.399-.078l.377-5.105s2.097-6.157 1.969-6.195"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        fillRule="evenodd"
        d="M47.938 24.08c5.124 0 8.243 2.326 9.73 6.175.43 1.113.698 2.295.837 3.512.078.685.107 1.242.112 1.866v13.739h-1l.002-5.527c-.604-.006-5.64-.208-5.775-5.267.201-.014 1.057 0 1.057 0a1.888 1.888 0 0 0 0-3.774h-1.65s-3.054-1.54-1.39-5.87c-1.873.31-4.663.576-6.364-1.726-.529.637-.987 1.413-1.38 2.315 1.307.12 2.16.91 2.184 2.454.02 1.226-.316 2.323-.94 3.509l-.179.328-.346.604a.63.63 0 0 0 .24.867l.086.04 1.351.505-.35.937-1.35-.505a1.63 1.63 0 0 1-.846-2.34l.342-.595.167-.308c.553-1.05.842-1.993.825-3.026-.016-1.055-.511-1.461-1.467-1.486h-.101c-.43 1.227-.76 2.642-.995 4.229-.434 2.925-.493 6.04-.331 8.877l.026.426.014.205h5.764v.064h1.828l-1.828 1.206v3.858h-1v-4.128h-5.678l-.07-.751-.028-.386-.027-.438c-.165-2.898-.105-6.077.341-9.08l.112-.701c.2-1.169.455-2.25.768-3.233l-.04.01-.136.035-.226.067-.156.054-.355-.935.089-.032.236-.076.305-.083q.336-.085.67-.134c1.373-3.48 3.618-5.48 6.922-5.48m-1.226 15.137.935.357c-.304.796-.821 1.35-1.483 1.681a3.36 3.36 0 0 1-1.709.348l-.078-.007.112-.993.028.002c.35.021.79-.038 1.2-.244a1.97 1.97 0 0 0 .92-.965zm-.76-6.135a.5.5 0 0 1 .493.41l.008.09v.66a.5.5 0 0 1-.992.09l-.008-.09v-.66a.5.5 0 0 1 .5-.5m-4.093 0a.5.5 0 0 1 .492.41l.008.09v.66a.5.5 0 0 1-.992.09l-.008-.09v-.66a.5.5 0 0 1 .5-.5"
        clipRule="evenodd"
      />
      <path
        fill="#06A7AC"
        fillRule="evenodd"
        d="M67.72 55.352s-3.395-7.18-15.493-7.499c-12.732-.335-17.563 5.756-18.82 7.5 0 0 7.343 5.502 18.82 5.235 9.127-.212 15.494-5.236 15.494-5.236"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        fillRule="evenodd"
        d="M12.22 21.63a5.896 5.896 0 0 1 5.479 8.077q1.384-.294 3.024-.295c3.494 0 5.868 2.12 7.32 5.81q.36.05.723.143l.323.088.249.08.094.034-.356.934-.166-.057a6 6 0 0 0-.387-.11l-.093-.022c.405 1.26.718 2.672.948 4.218.473 3.182.536 6.552.361 9.624l-.043.675-.042.514-.044.452h-6.026v4.407h-1v-4.055l-2.047-1.352h8.158l.032-.464.014-.234c.171-3.01.109-6.316-.352-9.42-.251-1.693-.604-3.202-1.063-4.509a2 2 0 0 0-.131-.001c-1.028.026-1.568.468-1.585 1.605-.017 1.1.29 2.105.878 3.223l.178.327.362.632c.499.87.14 1.965-.749 2.383l-.13.055-1.434.536-.35-.936 1.433-.536a.7.7 0 0 0 .362-1.005l-.368-.643-.189-.347c-.659-1.253-1.013-2.411-.993-3.705.025-1.636.934-2.463 2.33-2.577-.5-1.161-1.104-2.127-1.815-2.879-.46 3.636-4.91 7.79-8.704 8.29l-.209.002-.26.001h-.849l-.224-.002h-.208a2.002 2.002 0 0 0 0 4.003s.263-.005.54-.006h.342c.104 0 .19.002.239.006-.117 4.387-3.708 5.33-5.363 5.53v6.078h-1v-8.786a58 58 0 0 1 0-4.027v-1.35c-.004-.836.02-1.511.12-2.383.086-.757.22-1.502.408-2.227l.004-.014c.246-1.66.864-2.979 1.687-4.023a5.896 5.896 0 0 1 .572-11.763m9.775 23.813c.228.599.595.992 1.07 1.23.378.19.778.264 1.121.266l.197-.006.114.993-.082.007a3.53 3.53 0 0 1-1.798-.366c-.631-.317-1.137-.826-1.464-1.545l-.092-.222zm.834-6.485a.5.5 0 0 1 .491.41l.009.09v.7a.5.5 0 0 1-.992.09l-.008-.09v-.7a.5.5 0 0 1 .5-.5m4.341 0a.5.5 0 0 1 .492.41l.008.09v.7a.5.5 0 0 1-.992.09l-.008-.09v-.7a.5.5 0 0 1 .5-.5"
        clipRule="evenodd"
      />
      <path
        fill="#06A7AC"
        fillRule="evenodd"
        d="M.28 62.392s3.294-6.969 15.035-7.278c12.354-.325 17.042 5.587 18.263 7.278 0 0-7.127 5.34-18.263 5.08C6.458 67.267.28 62.393.28 62.393"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationPremiumSpotGroup;
